export default "__VITE_ASSET__xZQ2$ZYu__"